import { FeatureToggleClientService } from 'feature-toggle-client';
export const MonitoringItemPerPage = 'monitoring-item-per-page';
export const WidgetBlipChatHelpCenterMonitoring = 'widget-blip-chat-help-center-monitoring';
export const AutocompleFilters = 'attendance-monitoring-filters-autocomplete';
export const AttendantStatusCall = 'attendance-monitoring-status-call';
export const DesconnectSendAttendant = 'attendance-monitoring-send-disconnect-attendant';
export const UseCache = 'attendance-monitoring-use-cache';
export const AudioTranscriptionCopilot = 'audio-transcription-copilot';
export class DashboardFeatures {
    static isMonitoringItemPerPage() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(MonitoringItemPerPage);
    }
    static isWidgetBlipChatHelpCenterMonitoringEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(WidgetBlipChatHelpCenterMonitoring, false);
    }
    static isAutocompleFiltersEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AutocompleFilters, false);
    }
    static isStatusCallEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AttendantStatusCall, false);
    }
    static isDisconnectAttendant() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(DesconnectSendAttendant, false);
    }
    static isAudioTranscriptionCopilotEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AudioTranscriptionCopilot, false);
    }
    static isUseCacheEnable() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(UseCache, false);
    }
}
